import React from 'react'
import AppHeader from '../../Header'
import Footer from '../../Footer'
import PropTypes from 'prop-types'

const Layout = (props) => {
  const { showNav, showFooter, showNavResult, children } = props
  return (
    <>
      <AppHeader showNav={showNav} showNavResult={showNavResult} type='epic' />
      <div style={{ minHeight: '80vh' }}>
        {
          children
        }
      </div>
      <Footer show={showFooter} />
    </>
  )
}

Layout.propTypes = {
  showNav: PropTypes.bool,
  showFooter: PropTypes.bool,
  showNavResult: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default Layout
